import CalculatorsController from '../../src/javascripts/cvm';
import BestpassRoi from '../../src/javascripts/models/bestpass/roi';
import '../../src/javascripts/helpers/application/self_service_pdf_launcher';
import '../../src/javascripts/helpers/bestpass/benefit_selection_dependencies';
import '../../src/javascripts/helpers/bestpass/monthly_service_fee_calculator';
import '../../src/javascripts/helpers/bestpass/upfront_fee_calculator';
import '../../src/javascripts/helpers/bestpass/ss_input_hider';
import '../../src/stylesheets/bestpass/roi.scss';

(function() {
  $(() => CalculatorsController.run(new BestpassRoi()));
}).call(this);
